export default __webpack_public_path__ + "static/media/mOCEAN-MATIC.53098246.png";